import React from 'react'
import BookShelf from 'components/modular/shelves/book-shelf'
import withLazyLoad from 'utils/with-lazy-load'
import { useTranslation } from 'i18n'
import { MAX_SHELF_LENGTH } from '../contants'

import { Module } from 'api/data.types'
import { RunningRecordsBookShelfWrapper } from './RunningRecordsBookShelf.styles'
import { useRunningRecordsBookShelf } from './useRunningRecordsBookShelf'
import useUserPlatform from 'utils/hooks/use-platform'

const RunningRecordsBookShelf: React.FC = () => {
  const { isMobile } = useUserPlatform()
  const contentFilter = Module.INGLES
  const { content, loading, onClickBook, onClickBtnGetMore } =
    useRunningRecordsBookShelf()

  const { t } = useTranslation()
  const exceedsShelfLength = content.length >= MAX_SHELF_LENGTH

  if (loading || !content.length) {
    return null
  }

  return (
    <RunningRecordsBookShelfWrapper>
      <BookShelf
        loading={loading}
        contentFilter={contentFilter}
        title={t('Recomendados para o seu nível')}
        subtitle={''}
        size={isMobile ? 'large' : 'xlarge'}
        coversList={content}
        onClickCover={onClickBook}
        onClickBtnGetMore={onClickBtnGetMore}
        isSeeAllButtonVisible={exceedsShelfLength}
        showInfo
      />
    </RunningRecordsBookShelfWrapper>
  )
}
export default withLazyLoad({ once: true, height: 430, resize: true })(
  RunningRecordsBookShelf
)
